<div class="app-container" dir="rtl">
  <header class="app-header">
    <div class="header-title">وضعیت مانیتورهای OBD</div>

    <button class="back-btn" onclick="window.history.back()">
      <span>بازگشت</span>
      <span class="arrow">←</span>
    </button>
  </header>
  <div class="dashboard-container" dir="rtl">
    <div class="top-row">
      <div class="card header-card">
        <div class="card-title">
          <h2><i class="fa fa-microchip"></i> وضعیت آمادگی - PID 0101</h2>
          <p>پاسخ ECU بر اساس استاندارد OBD2</p>
        </div>

        <div class="status-list">
          <div class="status-item">
            <i
              class="fa fa-exclamation-triangle icon"
              [class.text-danger]="data.milOn"
              [class.text-success]="!data.milOn"
            ></i>
            <div class="text-group">
              <span class="label">{{ data.milLabel.fa }}</span>
              <span
                class="value"
                [class.text-danger]="data.milOn"
                [class.text-success]="!data.milOn"
              >
                {{ data.milOn ? "روشن" : "خاموش" }}
              </span>
            </div>
          </div>

          <div class="status-item">
            <i class="fa fa-bug icon text-purple"></i>
            <div class="text-group">
              <span class="label">{{ data.dtcCountLabel.fa }}</span>
              <span class="value text-purple">{{ data.dtcCount }}</span>
            </div>
          </div>

          <div class="status-item">
            <i class="fa fa-key icon text-info"></i>
            <div class="text-group">
              <span class="label">{{ data.ignitionTypeLabel.fa }}</span>
              <span class="value text-info">{{
                data.ignitionType || "نامشخص"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card summary-card">
        <h3 class="section-title">
          <i class="fa fa-pie-chart"></i> وضعیت خلاصه
        </h3>
        <div class="summary-list">
          <div class="summary-item">
            <i class="fa fa-check-circle icon text-success"></i>
            <div class="text-group">
              <span class="label">آماده</span>
              <span class="value text-success">2</span>
            </div>
          </div>
          <div class="summary-item">
            <i class="fa fa-hourglass-half icon text-warning"></i>
            <div class="text-group">
              <span class="label">در انتظار</span>
              <span class="value text-warning">3</span>
            </div>
          </div>
          <div class="summary-item">
            <i class="fa fa-ban icon text-muted"></i>
            <div class="text-group">
              <span class="label">پشتیبانی نشده</span>
              <span class="value text-muted">6</span>
            </div>
          </div>
          <div class="summary-item">
            <i class="fa fa-calculator icon text-purple"></i>
            <div class="text-group">
              <span class="label">کل</span>
              <span class="value text-purple">11</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card monitors-card" *ngIf="data.continuousMonitors.length">
      <h3 class="section-title">
        <i class="fa fa-list-ul"></i> {{ data.continuousMonitorsLabel.fa }}
      </h3>

      <div class="monitor-list">
        <div
          class="monitor-item"
          *ngFor="let monitor of data.continuousMonitors"
        >
          <span class="monitor-name">{{ monitor.titleFa }}</span>
          <span
            class="monitor-status"
            [ngClass]="{
              'status-yes': monitor.supported === true,
              'status-no': monitor.supported === false,
              'status-unsupported': monitor.supported === null
            }"
          >
            <i
              class="fa"
              [ngClass]="{
                'fa-check': monitor.supported === true,
                'fa-times': monitor.supported === false,
                'fa-minus': monitor.supported === null
              }"
            ></i>
            {{ monitor.supported ? "پشتیبانی شده" : "پشتیبانی نشده" }}
          </span>
        </div>
      </div>
    </div>

    <div class="card monitors-card" *ngIf="data.nonContinuousMonitors.length">
      <h3 class="section-title">
        <i class="fa fa-list-ul"></i> {{ data.nonContinuousMonitorsLabel.fa }}
      </h3>

      <div class="monitor-list">
        <div
          class="monitor-item"
          *ngFor="let monitor of data.nonContinuousMonitors"
        >
          <span class="monitor-name">{{ monitor.titleFa }}</span>
          <span
            class="monitor-status"
            [ngClass]="{
              'status-yes': monitor.supported === true,
              'status-no': monitor.supported === false,
              'status-unsupported': monitor.supported === null
            }"
          >
            <i
              class="fa"
              [ngClass]="{
                'fa-check': monitor.supported === true,
                'fa-times': monitor.supported === false,
                'fa-minus': monitor.supported === null
              }"
            ></i>
            {{ monitor.supported ? "پشتیبانی شده" : "پشتیبانی نشده" }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
